export default __webpack_public_path__ + "static/app-min-17cbe7ba27d4c96f31c232b4dc45dfcc.jpg";